import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modals-seguros',
  templateUrl: './modals-seguros.component.html',
  styleUrls: ['./modals-seguros.component.scss']
})
export class ModalSegurosComponent implements OnInit {
  @Input() public isOpen: boolean;
  @Input() public noUseHead: boolean;
  @Input() public noUseBody: boolean;
  @Input() public noUseFooter: boolean;
  @ViewChild('content') cldMdl: ElementRef;
  closeResult: string;

  constructor(private modalService: NgbModal) {
  }

  ngOnInit() {
    // this.open1();
  }

}
